export const initCopyLinks = (): void => {
    const copyButtons =
        document.querySelectorAll<HTMLElement>("[data-copy-button]");

    copyButtons.forEach((button) => {
        const container = button.closest("[data-copy-container]");
        const successElement = container?.querySelector("[data-copy-success]");

        if (!button || !container || !successElement) return;

        button.addEventListener("click", async () => {
            const url = window.location.href;
            let success = false;

            try {
                if ("clipboard" in navigator && navigator.clipboard.writeText) {
                    await navigator.clipboard.writeText(url);
                    success = true;
                } else {
                    console.warn(
                        "Clipboard API is not available in this browser.",
                    );
                }
            } catch (err: any) {
                if (!(err instanceof DOMException)) {
                    console.error("Error copying link:", err);
                }
            }

            if (success) {
                container
                    .querySelector("[data-copy-default]")
                    ?.classList.add("hidden");
                successElement.classList.remove("hidden");

                setTimeout(() => {
                    container
                        .querySelector("[data-copy-default]")
                        ?.classList.remove("hidden");
                    successElement.classList.add("hidden");
                }, 1000);
            }
        });
    });
};
